import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-othertransaction-menu',
  templateUrl: './othertransaction-menu.component.html',
  styleUrls: ['./othertransaction-menu.component.css']
})
export class OthertransactionMenuComponent implements OnInit {

  menuList:any;
  pageList:any;

  constructor() { }

  ngOnInit() {
    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    for(let i=0; i<this.menuList.length; i++){
      if(this.menuList[i].KHB_MenuName=='Other Transaction')
        this.pageList=this.menuList[i].KHB_PagesList;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/othertransaction/othertransaction-menu/othertransaction-menu.component.ts